<template lang="pug">
#editProcess
  flowEditor(ref="flowEditor" source="lowcode" noReturn :viewMode="viewMode" @closeDesigner="close" v-if="show")
</template>

<script>
// viewMode: 0, // 新增0 编辑1 查看2
import flowEditor from "@/CommonDP/components/processComponents/components/flowEditor.vue";
import { setGroupName, setFormList, setFormData, setFormFieldList } from "@/CommonDP/components/processComponents/config";
import flowService from "@/CommonDP/service/flow-service";
import metadataService from "@/CommonDP/service/metadata-service.js";

export default {
  components: {
    flowEditor
  },
  data () {
    return {
      show: false,
      viewMode: 1,
      parentId: "", // 业务流程的节点id
      groupId: "",
      parentParentID: ""
    };
  },
  inject: ["metaSideNode"],
  methods: {
    async getDetail(data) {
      const formlist = await this.formList();
      setFormList(formlist);
      this.show = false;
      const res = await flowService.queryFlowDef(data.currentVersionId, data.flowDefinitionId, data.flowKey);
      setFormData(res.data);
      const { formApprovePcCode, formCode } = res.data;
      const formId = formApprovePcCode || formCode;
      if (formId) this.queryFormColumns(formId);
      this.show = true;
    },
    async formList() {
      let node = this.metaSideNode();
      while (node.level > 2) node = node.parent;
      const data = node.childNodes.find((e) => e.label === "表单页面").data;
      const groupId = data.groupId;
      const templateType = data.templateType;
      return this.getChildNodeDataList(groupId, templateType);
    },
    async getChildNodeDataList(groupId, templateType) {
      const { data } = await metadataService.getChildNodeDataList(groupId, templateType);
      return data || [];
    },
    async queryFormColumns(formId) {
      const res = await flowService.queryFormColumns(formId);
      const array = res.data.filter((e) => e.isInternalField !== 1).map(e => {
        return {
          ...e,
          name: e.label,
          formField: e.name,
          isCanView: 1,
          isCanUpdate: 0,
          isRequired: e.required ? 1 : 0
        };
      }) || [];
      setFormFieldList('web', array);
    },
    dealNode(tree) {
      for (const iterator of tree) {
        if (this.parentId === iterator.groupId) {
          const paramsObj = {
            name: iterator.groupName + '-业务流程',
            id: this.parentId
          };
          setGroupName(paramsObj);
        }
        if (iterator.children && iterator.children.length > 0) {
          this.dealNode(iterator.children);
        }
      }
    },
    close() {

    }
  }
};
</script>

<style lang="scss" scoped>
#editProcess {
  width: 100%;
  height: 100%;
}
</style>
